const SliderDescriptions = {
  harassment: {
    '0.5': 'Blocks any potential harassment.',
    '0.6': 'Flags strong insults or repeated targeting.',
    '0.7': 'Allows mild criticism but flags aggression.',
    '0.8': 'Limits only severe threats or abuse.',
    '0.9': 'Allows most speech unless explicitly harmful.',
    '1': 'Allows all speech.',
  },
  hate: {
    '0.5': 'Blocks any hateful language.',
    '0.6': 'Flags discriminatory speech or slurs.',
    '0.7': 'Allows debate but blocks clear hate.',
    '0.8': 'Limits only extreme hate speech.',
    '0.9': 'Allows all but direct violent threats.',
    '1': 'Allows all speech.',
  },
  illicit: {
    '0.5': 'Blocks any illicit references.',
    '0.6': 'Flags crime-related discussions.',
    '0.7': 'Allows general discussion, blocks instructions.',
    '0.8': 'Limits only explicit illegal guidance.',
    '0.9': 'Allows most content unless highly dangerous.',
    '1': 'Allows all speech.',
  },
  'self-harm': {
    '0.5': 'Blocks all self-harm mentions.',
    '0.6': 'Flags distressing self-harm talk.',
    '0.7': 'Allows personal mentions, blocks encouragement.',
    '0.8': 'Limits only direct harm encouragement.',
    '0.9': 'Allows discussions unless highly explicit.',
    '1': 'Allows all speech.',
  },
  sexual: {
    '0.5': 'Blocks all sexual content.',
    '0.6': 'Flags explicit descriptions or services.',
    '0.7': 'Allows discussions, blocks graphic content.',
    '0.8': 'Limits only extreme explicit material.',
    '0.9': 'Allows most content except explicit abuse.',
    '1': 'Allows all speech.',
  },
  violence: {
    '0.5': 'Blocks all violent content.',
    '0.6': 'Flags threats or detailed harm.',
    '0.7': 'Allows discussions, blocks graphic descriptions.',
    '0.8': 'Limits only extreme violent content.',
    '0.9': 'Allows most unless highly graphic.',
    '1': 'Allows all speech.',
  },
};

export default SliderDescriptions;
